import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { ProjectStudiesStore } from '../stores/project-studies.store';
import { isNewStudyPageEnabled } from '../utils/new-study-page';
import { routeParamFromRoot } from './route-param';

/**
 * Loads a study's detail into `ProjectStudiesStore` before anything under `:studyId` renders, so the
 * shared consumers' synchronous reads (`StudyFacade.activeStudy`, `isActiveStudyCertified`, …) find it —
 * the guarantee the embedded project tree used to give. A no-op while the legacy page is on. Attached to
 * both study route tables: the model-search page mounts under the legacy one even with the new page on
 * (`project-feature-study-next.module.ts`).
 *
 * A failed load lets the navigation through: the page shows its own error state, and the synchronous
 * readers see `undefined`, as they do today for a study that does not exist.
 */
export const studyDetailResolver: ResolveFn<boolean> = route => {
  if (!isNewStudyPageEnabled()) {
    return true;
  }
  const studyId = routeParamFromRoot(route, 'studyId');
  if (!studyId) {
    return true;
  }
  return inject(ProjectStudiesStore)
    .ensureStudy(studyId)
    .pipe(
      map(() => true),
      catchError(() => of(true))
    );
};
